// import logo from "./logo.svg";
import React from 'react';
import About from './components/About';
import Contact from './components/Contact';
import Experience from './components/Experience';
import Footer from './components/Footer';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import Skills from './components/Skills';
// import Section from "./components/Section";
// import Header from "./components/Header";

function App() {
  return (
    <div className='bg-peach' >
    <div className="gap-4 ">
      <Navbar/>
      <Home />
      <About />
      {/* <Experience/>
      <Skills/> */}
      <Projects/>
      <Contact/>
    </div>
    </div>
  );
}

export default App;
